export function resetFilters() {
	window.filters_handler.ui.resetGlass();
}
